<template>
  <v-container>
    <GuideTour config-key="healthEducation.listView"/>

    <div class="py-8">
      <v-sheet outlined>
        <v-sheet color="grey-8" class="py-3">
          <div class="d-flex px-4">
            <div class="d-flex align-center" style="width: 400px; max-width: 70%; gap: 8px;">
              <div>搜尋</div>
              <v-text-field
                v-model="search"
                single-line
                hide-details
                outlined
                dense
                clearablea
                placeholder="名稱"
              />
            </div>
            <v-spacer/>
            <v-btn :icon="$vuetify.breakpoint.xsOnly" color="tiffany-9" dark elevation="0" large @click="$router.push({ name: 'HealthEducationNew' })">
              <v-icon>mdi-plus</v-icon>
              <template v-if="$vuetify.breakpoint.smAndUp">建立</template>
            </v-btn>
          </div>
        </v-sheet>

        <div>
          <v-data-table
            height="calc(100vh - 340px)"
            fixed-header
            :headers="headers"
            :items="dataset"
            :loading="loading"
            :search="search"
          >
            <template v-slot:item.action="{ item }">
              <v-btn icon color="tiffany-9" dark @click="$router.push({ name: 'HealthEducationEdit', params: { id: item.id } })">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </div>
  </v-container>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
import GuideTour from "@/components/utils/GuideTour.vue";
import { getHealthEducationAPI } from "@/api";
import { mapGetters } from "vuex";

export default {
  name: 'HealthEducationList',

  components: {GuideTour, Navigation},

  data() {
    return {
      loading: false,
      dataset: [],
      search: ''
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
    ]),
    headers() {
      return [
        {text: '名稱', value: 'keyword', sortable: false, width: 120},
        {text: '編輯', value: 'action', sortable: false, width: 150},
      ]
    }
  },

  mounted() {
    this.getHealthEducationList()
  },

  methods: {
    getHealthEducationList() {
      this.loading = true
      getHealthEducationAPI(this.axiosParamData).then(res => {
        this.dataset = res.data
      }).finally(() => {
        this.loading = false
      })
    },
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
